import {ReactElement} from 'react';
import classNames from 'classnames';

interface PopularSearchListProps {
  hidden: boolean;
  tokens: string[];
  onClick: (token: string) => void;
}

export default function PopularSearchList({
  hidden,
  tokens,
  onClick,
}: PopularSearchListProps): ReactElement {
  return (
    <div
      className={classNames('livesearch__popular', {hidden})}
      id="livesearch-popular"
    >
      <h5 className="livesearch__popular-title">
        You can add multiple search terms, press enter to add a search term
      </h5>
      <h6 className="c-accent">Popular Searches</h6>
      <div className="livesearch__popular-tokens">
        {tokens.map((token) => (
          <button
            key={token}
            type="button"
            className="popular-token js-popular-token"
            onClick={() => onClick(token)}
          >
            {token}
          </button>
        ))}
      </div>
    </div>
  );
}
